export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const buttonText = node.data.buttonText || ''
  const buttonType = node.data.buttonType || ''
  const valueByType = node.data.value || ''
  const buttonTypeText = node.data.text || ''

  let html = ''
  
  html += `<p><strong>Button name:</strong> ${buttonText}</p>`
  
  if ('post_back' === buttonType) {
    html += `<p><strong>Button type:</strong> Postback</p>`
    html += `<p><strong>Postback ID:</strong> ${buttonTypeText}</p>`
  } else if ('web_url' === buttonType) {
    html += `<p><strong>Button type:</strong> Web URL</p>`
    html += `<p><strong>Web URL:</strong> ${valueByType}</p>`
  } else if ([
    'web_url_full',
    'web_url_compact',
    'web_url_tall'
  ].indexOf(buttonType) > -1
  ) {
    let webviewUrl

    if ('web_url_full' === buttonType) {
      webviewUrl = 'Webview[FULL]'
    } else if ('web_url_compact' === buttonType) {
      webviewUrl = 'Webview[COMPACT]'
    } else if ('web_url_tall' === buttonType) {
      webviewUrl = 'Webview[TALL]'
    }

    html += `<p><strong>Button type:</strong> ${webviewUrl}</p>`
    html += `<p><strong>Webview URL:</strong> ${valueByType}</p>`
  } else if ('phone_number' === buttonType) {
    html += `<p><strong>Button type:</strong> Call Us</p>`
    html += `<p><strong>Mobile/Phone:</strong> ${valueByType}</p>`
  } else {
    html += `<p><strong>Button type:</strong> ${buttonTypeText}</p>`
  }

  if (! buttonText && ! buttonType) {
    $('#hover-node-card .card-body').html('')
  } else {
    $('#hover-node-card .card-body').html(html)
  }
}